var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTriangleDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 7,
    viewBox: "0 0 10 7",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.759049 0H9.24095C9.39109 3.89637e-05 9.53784 0.0541799 9.66266 0.155579C9.78748 0.256978 9.88477 0.401082 9.94222 0.569673C9.99967 0.738265 10.0147 0.923773 9.98542 1.10275C9.95614 1.28172 9.88386 1.44613 9.77771 1.57518L5.53676 6.72982C5.39439 6.90282 5.20132 7 5 7C4.79868 7 4.60561 6.90282 4.46324 6.72982L0.222287 1.57518C0.116142 1.44613 0.0438603 1.28172 0.0145794 1.10275C-0.0147015 0.923773 0.000333386 0.738265 0.0577829 0.569673C0.115232 0.401082 0.212517 0.256978 0.337339 0.155579C0.462161 0.0541799 0.608915 3.89637e-05 0.759049 0Z",
    fill: "black",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleDown);
export default __webpack_public_path__ + "static/media/triangleDown.ad2911c149197342b562337b4e78e775.svg";
export { ForwardRef as ReactComponent };